<template>
  <div class="loder-box" :style="boxStyle" v-show="show">
    <div class="m-loader" :style="centerStyle"/>
  </div>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      size: {
        type: String,
        default: 'box'
      },
      centerSize: {
        type: String,
        default: ''
      },
      height: {
        type: String,
        defualt: ''
      },
      width: {
        type: String,
        defualt: ''
      },
      show: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {

      }
    },
    computed: {
      centerStyle () {
        let style = {
          'smBox': {
            margin: '32px',
            'margin-bottom': '32px',
            width: '32px',
            height: '32px'
          },
          'box': {
            margin: '32px',
            'margin-bottom': '48px',
            width: '32px',
            height: '32px'
          },
          'font': {
            width: '1em',
            height: '1em',
            margin: '0 1em',
            padding: 0,
            display: 'inline-block'
          }
        }
        let result = style[this.size]
        if (!_.isEmpty(this.centerSize)) {
          result.width = this.centerSize
          result.height = this.centerSize
        }
        return result
      },
      boxStyle () {
        let style = {
          'box': {
            height: '100%',
            width: '100%',
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
          },
          'smBox': {
            height: '100%',
            width: '100%',
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
          },
          'font': {
            margin: 0,
            padding: 0,
            display: 'inline-block'
          },
          'before': {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
          }
        }
        let result = style[this.size]
        if (!_.isEmpty(this.height)) {
          result.height = this.centerSize
        }
        if (!_.isEmpty(this.width)) {
          result.width = this.centerSize
        }
        return result
      }
    },
    methods: {
    }
  }
</script>
<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/common/MLoader.vue